<template>
  <div class="item">
    <div class="title">
      <div class="left">
        <svg t="1663205701074" class="icon"
             viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg" p-id="1496"
             width="25" height="25">
          <path d="M362.666667 234.666667A64 64 0 0 1 426.666667 298.666667v85.333333a64 64 0 0 1-64 64H256A64 64 0 0 1 192 384V298.666667A64 64 0 0 1 256 234.666667h106.666667zM256 170.666667a128 128 0 0 0-128 128v85.333333a128 128 0 0 0 128 128h106.666667a128 128 0 0 0 128-128V298.666667a128 128 0 0 0-128-128H256zM362.666667 618.666667A64 64 0 0 1 426.666667 682.666667v85.333333a64 64 0 0 1-64 64H256A64 64 0 0 1 192 768v-85.333333A64 64 0 0 1 256 618.666667h106.666667zM256 554.666667a128 128 0 0 0-128 128v85.333333a128 128 0 0 0 128 128h106.666667a128 128 0 0 0 128-128v-85.333333a128 128 0 0 0-128-128H256zM768 234.666667A64 64 0 0 1 832 298.666667v85.333333a64 64 0 0 1-64 64h-106.666667A64 64 0 0 1 597.333333 384V298.666667a64 64 0 0 1 64-64H768zM661.333333 170.666667a128 128 0 0 0-128 128v85.333333a128 128 0 0 0 128 128H768a128 128 0 0 0 128-128V298.666667a128 128 0 0 0-128-128h-106.666667zM640 725.333333a32 32 0 0 1 32-32h149.333333a32 32 0 0 1 0 64h-149.333333A32 32 0 0 1 640 725.333333zM554.666667 608a32 32 0 0 1 32-32h234.666666a32 32 0 0 1 0 64h-234.666666a32 32 0 0 1-32-32zM554.666667 842.666667a32 32 0 0 1 32-32h234.666666a32 32 0 0 1 0 64h-234.666666a32 32 0 0 1-32-32z"
                p-id="1497"/>
        </svg>
        <span class="text">{{ item.label }}</span>
      </div>
      <div class="right" @click="loadMore">
        更多
        <svg t="1663287428679" class="icon"
             viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg" p-id="1498"
             width="25" height="25">
          <path d="M436.053333 308.053333a32 32 0 0 1 45.226667 0L685.226667 512l-203.946667 203.946667a32 32 0 1 1-45.226667-45.226667L594.773333 512l-158.72-158.72a32 32 0 0 1 0-45.226667z"
                p-id="1499"/>
        </svg>
      </div>
    </div>
    <div class="listContent">
      <li class="listItem"
          v-for="(content, key2) in item.listContents" :key="key2"
          @click="loadDetail(content)">
        <span class="text" v-if="content.title.length <= 42">{{ content.title }}</span>
        <span class="text" v-else>{{ content.title.slice(0, 42) }}...</span>
      </li>
    </div>
  </div>
</template>

<script>
  export default {
    name: "infoItem",
    props: ['item'],
    data() {
      return {}
    },
    methods: {
      // 展示更多信息
      loadMore() {
        if(this.item.route !== '' && this.item.route !== '/') {
          // 项目中路由跳转
          this.$router.push({ path: this.item.route });
        } else {
          // 打开新页面
          window.open(this.item.moreUrl, '_blank');
        }
      },
      loadDetail(content) {
        if(content.route !== '' && content.route !== '/') {
          // 项目中路由跳转
          this.$router.push({ path: content.route });
        } else {
          // 打开外部网页新页面
          window.open(content.url, '_blank');
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  path{
    fill: $mainColor;
  }
  .item{
    width: 100%;
    // 模块标题
    .title{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid $mainColor;
      .left{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        font-size: 18px;
        color: $mainColor;
        .text{
          margin: 3px 0 0 10px;
        }
      }
      .right{
        width: 20%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 13px;
        font-size: 14px;
        color: $mainColor;
        &:hover{
          cursor: pointer;
        }
      }
    }
    .listContent{
      list-style-type: disc;
      .listItem{
        margin: 15px 5px;
        font-size: 14px;
        .text{
          &:hover{
            cursor: pointer;
            color: $mainColor;
            border-bottom: 1px solid $mainColor;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/adv/components/infoItem.vue